var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAllAudioOn = function SvgAllAudioOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "all_audio_on_svg__st0",
    d: "M12 14.8c1.5 0 2.7-1.3 2.7-2.8V7.3c0-1.6-1.2-2.8-2.7-2.8S9.3 5.8 9.3 7.3V12c0 1.5 1.2 2.8 2.7 2.8zm4.3-4.7c-.4 0-.7.3-.7.7V12c0 2.2-1.8 3.9-3.9 3.7-1.9-.1-3.4-1.9-3.4-3.9v-1.1c0-.4-.3-.7-.7-.7s-.6.4-.6.8v.9c0 2.6 1.8 5 4.3 5.3v1h-1.1c-.5 0-.9.4-.9 1 0 .2.2.4.5.4h4.5c.2 0 .4-.2.5-.4 0-.5-.4-1-.9-1h-1.1v-1c2.4-.3 4.3-2.5 4.3-5.1v-1.2c-.1-.3-.4-.6-.8-.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "all_audio_on_svg__st0",
    d: "M12 1.5c5.8 0 10.5 4.7 10.5 10.5S17.8 22.5 12 22.5 1.5 17.8 1.5 12 6.2 1.5 12 1.5M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0z"
  })));
};
export default SvgAllAudioOn;